module.exports = __webpack_public_path__ + "img/1-10.495c03a3.png";